import {  
  Grid,
  TextField,
  Table,
  TableBody,
  TableCell,  
  TableRow  
} from '@material-ui/core';
import React, { Component } from 'react';
import { apiBatchRequest, downloadReport } from '../../utils/api_service';
import { API_URL } from '../../constants/api';
import commonLabels from '../../constants/messageConstants';
import { ShowToast, toastType } from '../../utils/toast-service';
import Reports from './Reports';
import { Switch } from '../common/Switch';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider
} from '@material-ui/pickers';
import './report.less';
import DateFnsUtils from '@date-io/date-fns';
import { DateFormat } from '../../constants/appConstants';
import moment from 'moment';
import PageHeader from '../common/PageHeader';
import Autocomplete from '@material-ui/lab/Autocomplete';
import _ from 'lodash';
import ReportButtons from './ReportButtons';
import AdvancedFilter from './AdvancedFilter';
import { GenerateAbsoluteURL, generatePDFFromHtml, getCurrentPayCycleEndDateByDate, getCurrentPayCycleStartDateByDate, removeDuplicates, disableDatesForPayCycleStart1, disableDatesForPayCycleEnd1, getValidEndDate, EnhancedTableHead, orderBy, getPreviousPayCycle, IsAutoRunPagesEnabled } from '../../utils/helper';
import { getMultilevelGroupedDataForBilling } from '../../utils/generic';
import { getFormattedHeaders, getFormattedValues, getFormattedValuesForReport } from '../../utils/formatData';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import TableWithPaginations from './TableWithPaginations';
import PageLandingMessage from '../common/PageLandingMessage/PageLandingMessage'

const changeInAllocationEmployeeByMarket = [
  { key: 'billedToCompany', dataFormat: 'MoneyDecimal', display: 'Billed To Market' },
  { key: 'billedToProperty', dataFormat: 'MoneyDecimal', display: 'Billed To Property' },
  { key: 'unreimbursedPayrollCost', dataFormat: 'MoneyDecimal', display: 'Unreimbursed Payroll Cost' }];
const headCells = [
  {
    id: 'billedToCompany',
    numeric: false,
    disablePadding: true,
    label: 'Billed To Market',
    type: 'MoneyDecimal'
  },
  {
    id: 'billedToProperty',
    numeric: false,
    disablePadding: true,
    label: 'Billed To Property',
    type: 'MoneyDecimal'
  },
  {
    id: 'unreimbursedPayrollCost',
    numeric: false,
    disablePadding: true,
    label: 'Unreimbursed Payroll Cost',
    type: 'MoneyDecimal'
  }
];
export default class EmployeeReimbursementsBilledAmount extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showMain: false,
      employeeData: [],
      employeeSummary: [],
      //   startDate: getCurrentPayCycleStartDateByDate(moment().format(DateFormat)),
      //   endDate: getCurrentPayCycleEndDateByDate(moment().format(DateFormat)),
      startDate: getPreviousPayCycle().previousPayCycleStartDate,
      endDate: getPreviousPayCycle().previousPayCycleEndDate,
      showReport: false,
      marketMasterData: [],
      market: [{ marketName: 'All' }],
      department: [{ departmentName: 'All' }],
      employee: [{ employeeName: 'All' }],
      SupervisorEmployee: [{ employeeName: 'All' }],
      openSlidingPanel: false,
      isAutoRunEnabled: IsAutoRunPagesEnabled(),
      isSubmitButtonClicked: false,
      advanceFilterConfig: {
        groupBy: {
          masterData: [
            {
              key: 'Department',
              id: 'department',
              value: 'department',
              ssrsReport: 'Department',
              numeric: false,
              disablePadding: false,
              label: 'Department',
              type: 'Text',
              order: 2
            },
            {
              key: 'Employee Name',
              value: 'employeeName',
              id: 'employeeName',
              ssrsReport: 'EmployeeName',
              numeric: false,
              disablePadding: false,
              label: 'Employee Name',
              type: 'Text',
              order: 3
            }],
          selected: [{
            key: 'Market Name',
            value: 'companyName',
            id: 'companyName',
            ssrsReport: 'CompanyName',
            numeric: false,
            disablePadding: false,
            label: 'Market Name',
            type: 'Text',
            order: 1
          }],
          startDate: getPreviousPayCycle().previousPayCycleStartDate,
          endDate: getPreviousPayCycle().previousPayCycleEndDate
        },
        selectedDate: {},
        suppressGraph: false,
        suppressZero: true,
        summaryRows: true,
        suppressDetails: false,
        showZeroNGraph: true,
        RadioSelect: 'CDR',
        order: 'asc',
        orderBy: 'companyName'
      },
      printPage: false,
      employeeMasterData: [],
      departmentMasterData: [],
      order: 'asc',
      orderBy: 'companyName',
      supervisorEmployeeMasterData: [],
      showTrueUpCredit: false
    };

    this.baseState = this.state;
  }

  componentDidMount() {
    this.GetMasterData();
  }

  GetMasterData = () => {
    this._asyncRequest = apiBatchRequest([
      {
        url: API_URL.Market.GetMarketMasterdata,
        key: 'marketMasterData',
        fromCache: true,
        duration: 15
      },
      {
        url: API_URL.Employee.GetDepartmentMasterData,
        key: 'departmentMasterData',
        fromCache: true,
        duration: 15
      },
      {
        url: API_URL.Employee.GetEmployeeMasterData + '?showInActive=true',
        key: 'employeeMasterData'
      }
    ])
      .then(({ marketMasterData, employeeMasterData, departmentMasterData }) => {
        this._asyncRequest = null;
        if (marketMasterData.success !== true) {
          ShowToast(
            commonLabels.somethingWrong,
            toastType.ERROR,
            5000,
            500,
            'Server error'
          );
        }
        this.setState({
          marketMasterData: marketMasterData.data,
          employeeMasterData: employeeMasterData.data,
          departmentMasterData: departmentMasterData.data,
          supervisorEmployeeMasterData: employeeMasterData.data || [],
        }, () => {
          if(this.state.isAutoRunEnabled || this.state.isSubmitButtonClicked) {
            this.handleSubmit();
          }          
        });
      })
      .catch(() => {
        this._asyncRequest = null;
      });
  };

  goBack = () => {
    this.setState({
      showMain: true
    });
  };

  handleDateChange = (date, name) => {
    const { advanceFilterConfig } = this.state;
    localStorage.setItem('DateRadioSelect', 'CDR');
    const formattedDate = moment(date).format(DateFormat);
    if (name === 'startDate') {
      advanceFilterConfig.startDate = formattedDate;// getCurrentPayCycleStartDateByDate(date).format(DateFormat);
      // localStorage.setItem('selectedstartDate', getCurrentPayCycleStartDateByDate(date).format(DateFormat));
      localStorage.setItem('selectedstartDate', formattedDate);
      this.setState({
        [name]: formattedDate// getCurrentPayCycleStartDateByDate(date).format(DateFormat)
      });
    } else {
      advanceFilterConfig.endDate = formattedDate;// getCurrentPayCycleEndDateByDate(date).format(DateFormat);
      // localStorage.setItem('selectedendDate', getCurrentPayCycleEndDateByDate(date).format(DateFormat));
      localStorage.setItem('selectedendDate', formattedDate);
      this.setState({
        [name]: formattedDate// getCurrentPayCycleEndDateByDate(date).format(DateFormat)
      });
    }
  };

  //Get Report Data based on selected filters
  GetEmployeeReimbursementsBilledAmounts = () => {
    const { startDate, endDate, market, employee, department, SupervisorEmployee, showTrueUpCredit } = this.state;
    const marketId = _.cloneDeep(market.map((x) => x.marketId));
    const employeeId = _.cloneDeep(employee.map((x) => x.employeeId));
    const departmentId = _.cloneDeep(department.map((x) => x.departmentId));
    const supervisorId = _.cloneDeep(SupervisorEmployee.map((x) => x.ultiProEmployeeId));

    const params = {
      startDate: moment(startDate).format(DateFormat),
      endDate: moment(endDate).format(DateFormat),
      marketId: marketId.join('|'),
      employeeId: employeeId.join('|'),
      departmentId: departmentId.join('|'),
      supervisorId: supervisorId.join('|'),
      showTrueUpCredit: showTrueUpCredit
    };
    this._asyncRequest = apiBatchRequest([
      {
        url: API_URL.Report.GetEmployeeReimbursementsBilledAmounts,
        params,
        key: 'employeeData'
      }
    ])
      .then(({ employeeData }) => {
        this._asyncRequest = null;
        if (employeeData.success !== true) {
          ShowToast(
            commonLabels.somethingWrong,
            toastType.ERROR,
            5000,
            500,
            'Server error'
          );
        }
        if (employeeData.data !== null && employeeData.data.length > 0 && this.state.advanceFilterConfig.suppressZero === true) {
          employeeData.data = employeeData.data.filter(x => {
            return x.billedToCompany !== 0 || x.billedToProperty !== 0;
          });
        }
        this.setState({
          employeeData: employeeData.data,
          employeeSummary: employeeData.config,
          showReport: true,
          isSubmitButtonClicked: true
        });
      })
      .catch(() => {
        this._asyncRequest = null;
      });
  };

  resetPage = () => {
    localStorage.setItem('selectedstartDate', getPreviousPayCycle().previousPayCycleStartDate);
    localStorage.setItem('selectedendDate', getPreviousPayCycle().previousPayCycleEndDate);
    localStorage.setItem('DateRadioSelect', 'CDR');
    const { advanceFilterConfig } = this.state;
    advanceFilterConfig.summaryRows = true;
    advanceFilterConfig.suppressZero = true;
    advanceFilterConfig.suppressDetails = false;
    advanceFilterConfig.startDate = getPreviousPayCycle().previousPayCycleStartDate;
    advanceFilterConfig.endDate = getPreviousPayCycle().previousPayCycleEndDate;

    advanceFilterConfig.groupBy = {
      masterData: [
        {
          key: 'Department',
          id: 'department',
          value: 'department',
          ssrsReport: 'Department',
          numeric: false,
          disablePadding: false,
          label: 'Department',
          type: 'Text',
          order: 2
        },
        {
          key: 'Employee Name',
          value: 'employeeName',
          id: 'employeeName',
          ssrsReport: 'EmployeeName',
          numeric: false,
          disablePadding: false,
          label: 'Employee Name',
          type: 'Text',
          order: 3
        }],
      selected: [{
        key: 'Market Name',
        value: 'companyName',
        id: 'companyName',
        ssrsReport: 'CompanyName',
        numeric: false,
        disablePadding: false,
        label: 'Market Name',
        type: 'Text',
        order: 1
      }]
    };
    this.setState({
      ...this.baseState,
      showReport: false,
      isSubmitButtonClicked: false,
      advanceFilterConfig
    }, () => {
      this.componentDidMount();
    });    
  };

  disableDatesForPayCycleStart = (date) => {
    return disableDatesForPayCycleStart1(date);
  }

  disableDatesForPayCycleEnd = (date) => {
    return disableDatesForPayCycleEnd1(date);
  }

  handleRequestSort = (event, property) => {
    const isAsc = this.state.orderBy === property && this.state.order === 'asc';
    this.setState({
      order: isAsc ? 'desc' : 'asc',
      orderBy: property
    });
  };

  renderTable = (rows) => {
    const groupSequence = this.getColumnSequence();
    return (
      <Table className="reportTable" id="rptTable" stickyHeader>
        <EnhancedTableHead
          order={this.state.order}
          orderBy={this.state.orderBy}
          onRequestSort={this.handleRequestSort}
          rowCount={rows.length}
          columnSequence={groupSequence}
          headCells={headCells}
        />
        <TableBody>
          {rows}</TableBody>
      </Table>
    );
  };

  getTableRow = (employeeData) => {
    const groupSequence = this.getColumnSequence();
    const suppressDetails = this.state.advanceFilterConfig.suppressDetails;
    let returnRows = [];

    employeeData?.length > 0 && returnRows.push((<TableRow className='rpt-topBorder parent-row'>
      <TableCell className='rpt rpt-odd  rpt-topBorder'>
        {getFormattedValues('Total', 'Text')}
      </TableCell>
      {((!suppressDetails) || (suppressDetails && groupSequence[1]?.value !== undefined)) && (
        <TableCell className='rpt rpt-odd  rpt-topBorder'>

        </TableCell>
      )}
      {((!suppressDetails) || (suppressDetails && groupSequence[2]?.value !== undefined)) && (
        <TableCell className='rpt rpt-odd  rpt-topBorder'>

        </TableCell>
      )
      }
      <TableCell className='rpt rpt-odd  rpt-topBorder'>
        {getFormattedValuesForReport(this.state.employeeData.reduce((total, obj) => (parseFloat(obj.billedToCompany) + parseFloat(total)), 0), 'MoneyDecimal')}
      </TableCell>
      <TableCell className='rpt rpt-odd  rpt-topBorder'>
        {getFormattedValuesForReport(this.state.employeeData.reduce((total, obj) => (parseFloat(obj.billedToProperty) + parseFloat(total)), 0), 'MoneyDecimal')}
      </TableCell>
      <TableCell className='rpt rpt-odd  rpt-topBorder'>
        {getFormattedValuesForReport(this.state.employeeData.reduce((total, obj) => (parseFloat(obj.unreimbursedPayrollCost) + parseFloat(total)), 0), 'MoneyDecimal')}
      </TableCell>
    </TableRow>));

    returnRows = [...returnRows, ...this.renderTableRow(
      orderBy(employeeData, this.state.orderBy, this.state.order)
    )];
    return returnRows;
  }

  renderTableRow = (data) => {
    const selectedGroupLength = this.state.advanceFilterConfig.groupBy.selected.length;
    if (selectedGroupLength > 0) {
      return this.renderTableCell(
        getMultilevelGroupedDataForBilling(
          data,
          this.state.advanceFilterConfig.groupBy.selected.map((x) => x.value)
        ),
        []
      );
    } else {
      return this.renderTableCell(
        getMultilevelGroupedDataForBilling(
          data,
          [] // this.state.advanceFilterConfig.groupBy.masterData.map((x) => x.value)
        ),
        []
      );
    }
  };

  renderTableCell = (groupedData, currentGroupedRow = [], tableCell = [], rowCount = 0) => {
    const showSummary = this.state.advanceFilterConfig.summaryRows;
    const suppressDetails = this.state.advanceFilterConfig.suppressDetails;
    const sequence = this.getColumnSequence();
    let column1 = showSummary ? (currentGroupedRow.find(x => x.key === sequence[0]?.value) || {}).value ?? '' : '';
    let column2 = showSummary ? (currentGroupedRow.find(x => x.key === sequence[1]?.value) || {}).value ?? '' : '';
    let column3 = showSummary ? (currentGroupedRow.find(x => x.key === sequence[2]?.value) || {}).value ?? '' : '';

    groupedData.forEach((d, i) => {
      if (d.data !== undefined) {
        rowCount = 0;
        currentGroupedRow = currentGroupedRow.filter(x => x.key !== d.key);
        currentGroupedRow.push({ key: d.key, value: d[d.key] });
        if (this.state.advanceFilterConfig.summaryRows === false) {
          this.renderTableCell(d.data, currentGroupedRow, tableCell, rowCount);
        }
      }
      const keyvalue = this.adjustColumnSequence(_.cloneDeep(currentGroupedRow));
      const sequence = this.getColumnSequence();

      if (d.isGroup !== true || this.state.advanceFilterConfig.summaryRows === true) {
        const evenOddClass =
          tableCell.length % 2 === 0 ? ' rpt rpt-even ' : ' rpt rpt-odd ';
        const topBorderClass =
          column1 !== (keyvalue.find(x => x.key === sequence[0]?.value) || {}).value ?? '' ? ' rpt-topBorder ' : ' ';
        const key = d.marketId + '_' + d.departmentId + '_' + d.employeeId + '_' + d.companyName + '_' + d.department + '_' + d.employeeName + '_' + rowCount + '_' + i;
        if ((suppressDetails && d.isGroup) || (!suppressDetails)) {
          tableCell.push(
            <TableRow
              //  key={key}
              className={topBorderClass + (d.isGroup === true ? ' parent-row' : '')}
            >
              {((!suppressDetails) || (suppressDetails && sequence[0]?.value !== '' && sequence[0]?.value !== undefined)) && (
                <TableCell
                  className={evenOddClass + topBorderClass}
                >
                  {getFormattedValues(column1 !== d[sequence[0]?.value] && d[sequence[0]?.value], 'Text')}{' '}
                </TableCell>)
              }
              {((!suppressDetails) || (suppressDetails && sequence[1]?.value !== '' && sequence[1]?.value !== undefined)) && (
                <TableCell
                  className={
                    evenOddClass + ' rpt-topBorder '
                  }
                >
                  {getFormattedValues(column2 !== d[sequence[1]?.value] && d[sequence[1]?.value], 'Text')}{' '}

                </TableCell>
              )
              }
              {((!suppressDetails) || (suppressDetails && sequence[2]?.value !== '' && sequence[2]?.value !== undefined)) && (
                <TableCell
                  className={
                    evenOddClass + ' rpt-topBorder '
                  }
                >
                  {getFormattedValues(column3 !== d[sequence[2]?.value] && d[sequence[2]?.value], 'Text')}{' '}
                </TableCell>
              )
              }
              {changeInAllocationEmployeeByMarket.map((element, ind) =>
              (
                <TableCell key={key + ind} className={evenOddClass + 'rpt-topBorder'}>
                  {getFormattedValuesForReport(d[element.key], element.dataFormat)}{' '}
                </TableCell>
              ))}
            </TableRow>
          );
        }
        rowCount++;
        column1 = (keyvalue.find(x => x.key === sequence[0]?.value) || {}).value ?? '';
        column2 = (keyvalue.find(x => x.key === sequence[1]?.value) || {}).value ?? '';
        column3 = (keyvalue.find(x => x.key === sequence[2]?.value) || {}).value ?? '';
      }
      if (d.data !== undefined && this.state.advanceFilterConfig.summaryRows === true) {
        this.renderTableCell(d.data, currentGroupedRow, tableCell, rowCount);
      }
    });

    return tableCell;
  }

  // Click event of Submit button
  handleSubmit = () => {
    localStorage.setItem('DateRadioSelect', 'CDR');
    localStorage.setItem('selectedstartDate', this.state.startDate);
    localStorage.setItem('selectedendDate', this.state.endDate);
    this.GetEmployeeReimbursementsBilledAmounts();
  };

  handleClickOpen = () => {
    localStorage.setItem('selectedstartDate', this.state.startDate);
    localStorage.setItem('selectedendDate', this.state.endDate);
    this.setState({
      openSlidingPanel: true
    });
  };

  handlePrintClick = () => {
    this.setState(
      {
        printPage: true
      },
      window.print()
    );
  };

  // Advanced Filter

  onAddvanceFilterChange = (advanceFilterConfig) => {
    // const {newAdvanceFilterConfig} = this.state.advanceFilterConfig;
    localStorage.setItem('selectedstartDate', this.state.startDate);
    localStorage.setItem('selectedendDate', this.state.endDate);
    //   const endDate = getValidEndDate(advanceFilterConfig);
    this.setState({
      advanceFilterConfig: advanceFilterConfig,
      openSlidingPanel: false
      // startDate: getCurrentPayCycleStartDateByDate(advanceFilterConfig.startDate),
      // endDate: getCurrentPayCycleEndDateByDate(endDate)
    }, () => this.GetEmployeeReimbursementsBilledAmounts());
  }

  getColumnSequence = () => {
    if (this.state.advanceFilterConfig.suppressDetails) {
      return removeDuplicates([...this.state.advanceFilterConfig.groupBy.selected], 'key');
    } else {
      if (this.state.advanceFilterConfig.groupBy.selected.length === 0) {
        return removeDuplicates(
          [
            // ...this.state.advanceFilterConfig.groupBy.selected,
            ...this.state.advanceFilterConfig.groupBy.masterData
          ],
          'key'
        );
      } else {
        return removeDuplicates(
          [
            ...this.state.advanceFilterConfig.groupBy.selected,
            ...this.state.advanceFilterConfig.groupBy.masterData
          ],
          'key'
        );
      }
    }
  };

  adjustColumnSequence = (currentGroupedRow) => {
    this.state.advanceFilterConfig.groupBy.masterData.forEach(x => {
      currentGroupedRow.push({ key: x.value });
    }
    );
    return currentGroupedRow;
  }

  handleClose = () => {
    this.setState({
      openSlidingPanel: false
    });
  };

  // Click event of switch button "Show Detailed TrueUp/Credit Records". 
  // It will set true/false value to the variable showTrueUpCredit
  // If the value is true, it will show pay period wise trueUp/Credit records
  // If the value is false, it will show Employee and Property wise summarized TrueUp/Credit records
  isAcceptCondition = (checked) => {
    this.setState({ showTrueUpCredit: checked });
  }

  handleChange = (_e, value, name, optionLabel) => {
    if ((this.state[name] || []).find(x => x[optionLabel] === 'All') === undefined) {
      if (value && value.length === 0) {
        value = [{ [optionLabel]: 'All' }];
        this.setState({ [name]: value });
      } else if ((value || []).find(x => x[optionLabel] === 'All')) {
        this.setState({ [name]: [{ [optionLabel]: 'All' }] });
      } else {
        this.setState({ [name]: value });
      }
    } else {
      value = (value || []).filter(x => x[optionLabel] !== 'All');
      if (value && value.length === 0) {
        value = [{ [optionLabel]: 'All' }];
      }
      this.setState({ [name]: value });
    }
  };

  // download report into selected format
  downloadFile = (fileMimeType, type, isPrint) => {
    let { market, department, employee, advanceFilterConfig, startDate, endDate, SupervisorEmployee, showTrueUpCredit } = this.state;
    const dataValue = [
      { key: 'StartDate', value: moment(startDate).format(DateFormat) },
      { key: 'EndDate', value: moment(endDate).format(DateFormat) }
    ];
    market = market.filter(x => x.marketName !== 'All');
    department = department.filter(x => x.departmentName !== 'All');
    employee = employee.filter(x => x.employeeName !== 'All');
    const marketId = _.cloneDeep(market.map((x) => x.marketId));
    const departmentId = _.cloneDeep(department.map((x) => x.departmentId));
    const employeeId = _.cloneDeep(employee.map((x) => x.employeeId));
    const supervisorId = _.cloneDeep(SupervisorEmployee.map((x) => x.ultiProEmployeeId));

    if (market && market.length > 0) {
      dataValue.push({ key: 'MarketId', value: marketId.join('|') === undefined ? '' : marketId.join('|') });
    }
    if (department && department.length > 0) {
      dataValue.push({ key: 'DepartmentId', value: departmentId.join('|') === undefined ? '' : departmentId.join('|') });
    }

    if (employee && employee.length > 0) {
      dataValue.push({ key: 'EmployeeId', value: employeeId.join('|') === undefined ? '' : employeeId.join('|') });
    }

    if (supervisorId && supervisorId.length > 0) {
      dataValue.push({ key: 'supervisorId', value: supervisorId.join('|') === undefined ? '' : supervisorId.join('|') });
    }
    dataValue.push({ key: 'ShowTrueUpCredit', value: showTrueUpCredit });
    const url = GenerateAbsoluteURL(dataValue, advanceFilterConfig.groupBy.selected, 'Employee%20Reimbursements%20Billed%20Amounts', type);
    downloadReport(
      url,
      'Employee Reimbursements Billed Amounts',
      fileMimeType,
      type,
      isPrint
    );
  }

  render() {
    const {
      showMain,
      employeeData,
      startDate,
      endDate,
      marketMasterData,
      showReport,
      employeeMasterData,
      advanceFilterConfig,
      departmentMasterData,
      openSlidingPanel,
      supervisorEmployeeMasterData,
      showTrueUpCredit
    } = this.state;

    if (marketMasterData.find(x => x.marketName === 'All') === undefined) {
      marketMasterData.unshift({ marketName: 'All' });
    }
    if (employeeMasterData.find(x => x.employeeName === 'All') === undefined) {
      employeeMasterData.unshift({ employeeName: 'All' });
    }
    if (departmentMasterData.find(x => x.departmentName === 'All') === undefined) {
      departmentMasterData.unshift({ departmentName: 'All' });
    }

    if (supervisorEmployeeMasterData.find(x => x.employeeName === 'All') === undefined) {
      supervisorEmployeeMasterData.unshift({ employeeName: 'All' });
    }

    const rows = this.getTableRow(employeeData);
    return (
      <div>
        {showMain
          ? (
            <Reports />
          )
          : (
            <>
              <PageHeader
                key={'Employee_Cost_vs_Reimbursement_Report'}
                title={'Employee Reimbursements Billed Amounts'}
                actionsConfig={[
                  {
                    icon: <ArrowBackIcon size="small" className="back-button" />,
                    onClick: this.goBack,
                    title: 'Back to Report'
                  }
                ]}
              >
                Employee Reimbursements Billed Amounts
              </PageHeader>
              <Grid container spacing={3} className='no-print row bottom-xs' style={{ marginLeft: '10px' }} >
                <Grid item xs={12} lg={2}>
                  <Grid item xs={12}>
                    <Autocomplete
                      multiple
                      blurOnSelect
                      limitTags={1}
                      value={this.state.market}
                      onChange={(e, val) => this.handleChange(e, val, 'market', 'marketName')}
                      id="tags-standard"
                      options={removeDuplicates(marketMasterData, 'marketName')}
                      getOptionLabel={(option) => option.marketName}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="standard"
                          label="Market"
                        // placeholder="Market"
                        />
                      )}
                    />
                  </Grid>
                </Grid>
                <Grid item xs={12} lg={2}>
                  <Grid item xs={12}>
                    <Autocomplete
                      multiple
                      blurOnSelect
                      limitTags={1}
                      id="tags-standard"
                      value={this.state.department}
                      options={removeDuplicates(departmentMasterData, 'departmentName')}
                      getOptionLabel={(option) => option.departmentName}
                      onChange={(e, val) => this.handleChange(e, val, 'department', 'departmentName')}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="standard"
                          label="Department"
                        // placeholder="Employee Name"
                        />
                      )}
                    />
                  </Grid>
                </Grid>
                <Grid item xs={12} lg={2}>
                  <Grid item xs={12}>
                    <Autocomplete
                      multiple
                      blurOnSelect
                      limitTags={1}
                      id="tags-standard"
                      value={this.state.employee}
                      options={removeDuplicates(employeeMasterData, 'employeeName')}
                      getOptionLabel={(option) => option.employeeName}
                      onChange={(e, val) => this.handleChange(e, val, 'employee', 'employeeName')}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="standard"
                          label="Employee"
                        // placeholder="Employee Name"
                        />
                      )}
                    />
                  </Grid>
                </Grid>
                <Grid item xs={12} lg={2}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <Grid container>
                      <KeyboardDatePicker
                        margin="normal"
                        id="date-picker-dialog"
                        label="Start Date"
                        format="MM/dd/yyyy"
                        name="startDate"
                        // maxDate={endDate}
                        value={startDate}
                        onChange={(e) => this.handleDateChange(e, 'startDate')}
                        KeyboardButtonProps={{
                          'aria-label': 'change date'
                        }}
                        className="w-100"
                        shouldDisableDate={this.disableDatesForPayCycleStart}
                      />
                    </Grid>
                  </MuiPickersUtilsProvider>
                </Grid>
                <Grid item xs={12} lg={2}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <Grid container>
                      <KeyboardDatePicker
                        margin="normal"
                        id="date-picker-dialog"
                        label="End Date"
                        format="MM/dd/yyyy"
                        name="endDate"
                        minDate={startDate}
                        value={endDate}
                        onChange={(e) => this.handleDateChange(e, 'endDate')}
                        KeyboardButtonProps={{
                          'aria-label': 'change date'
                        }}
                        className="w-100"
                        shouldDisableDate={this.disableDatesForPayCycleEnd}
                      // maxDate={getCurrentPayCycleEndDateByDate(moment().format('MM/DD/YYYY'))}
                      />
                    </Grid>
                  </MuiPickersUtilsProvider>
                </Grid>
                <AdvancedFilter
                  filterConfig={advanceFilterConfig}
                  onApplyFilter={this.onAddvanceFilterChange}
                  openSlidingPanel={openSlidingPanel}
                  handleClose={this.handleClose}
                />
                <ReportButtons
                  resetPage={this.resetPage}
                  handleSubmit={this.handleSubmit}
                  handleClickOpen={this.handleClickOpen}
                  handlePrintClick={this.handlePrintClick}
                  downloadFile={this.downloadFile}
                  data={employeeData}
                />
                <Grid item xs={12} lg={2}>
                  <Autocomplete
                    multiple
                    limitTags={1}
                    blurOnSelect
                    id="tags-standard"
                    value={this.state.SupervisorEmployee || ''}
                    options={removeDuplicates(supervisorEmployeeMasterData, 'employeeName')}
                    getOptionLabel={(option) => option.employeeName}
                    onChange={(e, val) => {
                      this.handleChange(e, val, 'SupervisorEmployee', 'employeeName');
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="standard"
                        label="Supervisor Name"
                      // placeholder="Employee Name"
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} lg={2}>
                    <Grid item xs={12} style={{ marginTop: '10px' }}>
                      <Switch
                        isChecked={showTrueUpCredit}
                        onChangeValues={(checked, key) => {
                          this.isAcceptCondition(checked);
                        }}
                        id={'switch-trueup_credit_records_id'}
                        labelText={'Show Detailed TrueUp/Credit Records'}
                        fullWidth
                      />
                    </Grid>                  
                  </Grid>
              </Grid>
              {(this.state.isAutoRunEnabled === false && this.state.isSubmitButtonClicked === false) && 
                (employeeData === null || employeeData.length <= 0) && (
                  <PageLandingMessage/>
                )
              }
              {showReport && (employeeData == null || employeeData.length <= 0) && (
                <Grid container spacing={4}>
                  <Grid
                    container
                    direction="row-reverse"
                    justify="center"
                    alignItems="stretch"
                  >
                    <label className="item-big">No Data Available.</label>
                  </Grid>
                </Grid>
              )}
              {showReport && (
                <div>
                  {employeeData !== null && employeeData.length > 0 &&
                    <TableWithPaginations
                      tableData={rows}
                      renderTable={this.renderTable}
                      order={this.state.order}
                      oBy={this.state.orderBy}

                    />}
                </div>
              )}
            </>
          )}
      </div>
    );
  }
}
